
export function useTabs(tabs: Ref<{ name: string; component: Component; query: string }[]>) {
  const activeTab = ref(0);
  const route = useRoute();
  const router = useRouter();

  // Capture the route this composable was mounted on so we don't try to
  // rewrite the query while navigating away to a different route.
  const ownerRouteName = route.name;

  // Watch the query parameter to update the active tab
  watch(
    () => route.query.tab,
    (newTab) => {
      // Bail out if we've navigated away from the route that owns these tabs.
      if (route.name !== ownerRouteName) return;

      const tabIndex = tabs.value.findIndex((tab) => tab.query === newTab);
      if (tabIndex !== -1) {
        activeTab.value = tabIndex;
      } else if (tabs.value.length > 0) {
        // Default to the first tab if no valid query is found
        activeTab.value = 0;
        router.replace({ query: { tab: tabs.value[0]?.query ?? '' } });
      }
      // If tabs.value is empty, do nothing
    },
    { immediate: true },
  );

  // Function to set the active tab safely
  const setActiveTab = (index: number) => {
    const tab = tabs.value[index];
    if (!tab) return; // Guard: index out of bounds

    activeTab.value = index;
    router.push({ query: { tab: tab.query } });
  };

  return {
    activeTab,
    setActiveTab,
  };
}
